<template>
  <div
    v-if="provider && providerUid"
    :class="$style.root"
  >
    <client-only>
      <Player controls>
        <Vimeo
          v-if="provider === 'vimeo'"
          :videoId="providerUid"
        />
        <Youtube
          v-else-if="provider === 'youtube'"
          :videoId="providerUid"
        />
      </Player>
    </client-only>
  </div>
</template>

<script lang="ts" setup>
import '@vime/core/themes/default.css'
import { Player, Vimeo, Youtube } from '@vime/vue-next';

const props = defineProps({
  block: Object
})

const provider = computed(() => {
  return props?.block?.video?.provider
})

const providerUid = computed(() => {
  return props?.block?.video?.providerUid
})
</script>

<style module>
.root {
  composes: container--medium from global;
}
</style>
